import { ReactNode } from 'react';
import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  HStack,
  IconButton,
  useDisclosure,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import Navbar from './nav/Navbar';

const BasePage = (props: { children: ReactNode }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <HStack minH="100vh" w="100vw" overflowX="hidden">
        <Box bg="#ffffff" w="200px" display={{ base: 'none', lg: 'block' }}>
          <Navbar />
        </Box>

        <Box
          paddingY={8}
          paddingX={{ base: 8, md: 12 }}
          h="100vh"
          width="100vw"
          bg="#F8F9FA"
          overflowY="auto"
        >
          <IconButton
            aria-label="Open Menu"
            icon={<HamburgerIcon />}
            display={{ base: 'block', lg: 'none' }}
            onClick={onOpen}
            position="fixed"
            top="1rem"
            right="1rem"
            zIndex={1000}
          />
          {props.children}
        </Box>
      </HStack>

      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent maxW="180px" w="180px">
          <Navbar />
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default BasePage;
